import { useMemo } from "react";
import {
  crudRoutes,
  expeditionRoutes,
  externalRouter,
  generalRoutes,
} from "./routesConstants";
import userRoles from "../constants/userRoles";

interface DashboardCategories {
  title: string;
  subtitle?: string;
  subtitleValue?: string;
  categories: {
    id: string;
    title: string;
    path: string;
    openInNewTab?: boolean;
    subtitle?: string;
    value?: string | number;
    isIncreasing?: boolean;
  }[];
  navigationLinks?: {
    link: string;
    label: string;
  }[];
}

function useAppMenuRoutes() {
  const transportRoutes = useMemo(
    () => [
      {
        id: userRoles.PREVIEW_USERS,
        title: "Istoric expeditii",
        path: `/`,
      },
      {
        id: userRoles.CREATE_USER,
        title: "Plasare comanda",
        path: `/${generalRoutes.createAwb}`,
      },
      {
        id: userRoles.CREATE_USER,
        title: "Formeaza BIN",
        path: `/${generalRoutes.createBin}`,
      },
      {
        id: userRoles.CREATE_USER,
        title: "Vezi istoric colet",
        path: externalRouter.translogTracking,
        openInNewTab: true,
      },
    ],
    [],
  );

  const clientWorkingPoints = useMemo(
    () => [
      {
        id: userRoles.SCHEDULE_WORKING_POINTS,
        title: "Puncte de lucru",
        path: `/${expeditionRoutes.clientWorkingPoints}`,
      },
      {
        id: userRoles.WORKING_POINTS_ORGANIZE,
        title: "Creeaza punct de lucru",
        path: `/${expeditionRoutes.clientWorkingPoints}/${crudRoutes.create}`,
      },
      {
        id: userRoles.UNDELIVERED_AWB,
        title: "Comenzi nefinalizate",
        path: `/${expeditionRoutes.undeliveredAwb}`,
      },
      {
        id: userRoles.UNDELIVERED_BINS,
        title: "Binuri nefinalizate",
        path: `/${expeditionRoutes.undeliveredBins}`,
      },
    ],
    [],
  );

  const categories: DashboardCategories[] = useMemo(
    () =>
      [
        {
          title: "Comenzi",
          categories: transportRoutes,
        },
        {
          title: "Clienti",
          categories: clientWorkingPoints,
        },
      ].filter((category) => category.categories.length > 0),
    [transportRoutes, clientWorkingPoints],
  );

  return categories;
}

export default useAppMenuRoutes;
